<app-system-maintenance-status></app-system-maintenance-status>

<!-- ngx-sonner Toaster Component -->
<ngx-sonner-toaster position="top-right" [richColors]="true" [closeButton]="false" [duration]="3000" [visibleToasts]="5"
    [expand]="true" />

<!-- Subscription Ended Dialog - Shows only for authenticated users with ended subscriptions -->
<app-dialog [visible]="subscriptionDialogVisible()" [showCloseButton]="true" [fullscreenOnMobile]="true"
    class="max-w-[40rem]" (closed)="onSubscriptionDialogVisibleChange(false)">
    <ng-template #bodyTemplate>
        <div class="flex flex-col justify-between items-center gap-4 p-6">
            <p class="text-2xl font-semibold text-gray-700">
                {{ getDialogMessage() | textCase }}
            </p>
            <div class="relative card w-full flex justify-center items-center">
                <img src="/icons/subscription.svg" alt="Subscription Ended"
                    class="z-10 align-middle relative w-[80%] h-full">
            </div>

            @if(ENV.enableSubscription) {
            @if(hasBillingAccess) {
            <app-button variant="outlined" severity="theme" (clicked)="talkToSales()" [enableThrottle]="true"
                label="{{'Talk To Sales' | textCase}}" />
            <app-button variant="filled" severity="theme" (clicked)="navigateToPricing()"
                label="{{'Activate your plan' | textCase}}" />
            } @else {
            <span class="text-gray-700 text-center text-sm italic">Please contact your account owner to activate
                a plan and restore access</span>
            }
            } @else {
            <app-button variant="outlined" severity="theme" (clicked)="talkToSales()" [enableThrottle]="true"
                label="{{'Talk To Sales' | textCase}}" />
            }
        </div>
    </ng-template>
</app-dialog>

<app-phone-number-dialog [(visible)]="showPhoneNumberDialog" (phoneNumberSubmitted)="onPhoneNumberSubmitted()">
</app-phone-number-dialog>

<div class="flex flex-col h-screen overflow-hidden">
    <app-banner />
    <div class="flex flex-1 min-w-0 overflow-hidden transition-all duration-200"
        [class.px-2]="isChatSidebarOpen()"
        [class.gap-2]="isChatSidebarOpen()"
        [class.bg-gray-100]="isChatSidebarOpen()">
        <div class="flex-1 min-w-0 overflow-hidden app-content transition-all duration-200"
            [class.blurred]="blurScreen"
            [class.rounded-lg]="isChatSidebarOpen()"
            [class.shadow-xl]="isChatSidebarOpen()">
            <router-outlet></router-outlet>
        </div>
        <app-chat-sidebar />
    </div>
</div>
